import List from 'containers/Roles/List';
import Create from 'containers/Roles/Create';
import Edit from 'containers/Roles/Edit';

export default { List, Create, Edit };
